import en from './en.json';
import de from './de.json';

const usersLocales = {
  en,
  de,
};

export default usersLocales;
